import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=47a4401a&scoped=true&"
import script from "./TransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransactionForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=47a4401a&prod&scoped=true&lang=css&"
import style1 from "./TransactionForm.vue?vue&type=style&index=1&id=47a4401a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4401a",
  null
  
)

export default component.exports